import React, { useState } from 'react';
import { Bell } from 'lucide-react';
import { COLORS } from '../../../../utils/constants';
import { adminAPI } from '../../../../services/api';
import { useAdminToast } from '../../../../hooks/useAdminToast';
import { ModalWrapper, FormInput } from './ModalComponents';

const MassNotificationModal = ({ selectedClients, onClose, onSuccess }) => {
  const { toast } = useAdminToast();
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!title || !message) return;
    setLoading(true);
    try {
      await adminAPI.massNotification(selectedClients, title, message, 'system');
      toast.success(`Уведомление отправлено ${selectedClients.length} клиентам`);
      onSuccess();
    } catch (err) {
      toast.apiError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalWrapper title="Массовая рассылка уведомлений" onClose={onClose}>
      <div style={{ padding: '16px', backgroundColor: COLORS.background, borderRadius: '8px', marginBottom: '16px' }}>
        <div style={{ color: COLORS.textSecondary, fontSize: '13px', marginBottom: '4px' }}>Получателей</div>
        <div style={{ color: '#3b82f6', fontSize: '28px', fontWeight: '700' }}>{selectedClients.length}</div>
      </div>

      <FormInput label="Заголовок" value={title} onChange={setTitle} />
      
      <div style={{ marginBottom: '20px' }}>
        <label style={{ display: 'block', color: COLORS.textSecondary, fontSize: '13px', marginBottom: '6px' }}>Сообщение</label>
        <textarea 
          value={message} 
          onChange={(e) => setMessage(e.target.value)} 
          placeholder="Текст уведомления..." 
          rows={4}
          style={{ 
            width: '100%', 
            padding: '12px', 
            backgroundColor: COLORS.background, 
            border: `1px solid ${COLORS.border}`, 
            borderRadius: '8px', 
            color: COLORS.text, 
            fontSize: '14px', 
            boxSizing: 'border-box',
            resize: 'vertical',
          }} 
        />
      </div>

      <button 
        onClick={handleSubmit} 
        disabled={loading || !title || !message} 
        style={{ 
          width: '100%', 
          padding: '14px', 
          backgroundColor: loading || !title || !message ? COLORS.border : '#3b82f6', 
          border: 'none', 
          borderRadius: '8px', 
          color: '#fff', 
          fontSize: '15px', 
          fontWeight: '600', 
          cursor: loading || !title || !message ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px'
        }}
      >
        <Bell size={18} />
        {loading ? 'Отправка...' : 'Отправить уведомления'}
      </button>
    </ModalWrapper>
  );
};

export default MassNotificationModal;
